import React, { Component, Fragment } from 'react';
import Form from 'react-jsonschema-form';
import { Button, TableBody, TableRow, TableCell, Box, IconButton } from '@material-ui/core';
import { AccountCircle, Close, Create, EditRounded, CloseRounded } from '@material-ui/icons';
import { MiniCard } from '../../../commonModules/layouts/CardPage';
import { TableLayout } from '../Stock/containers/Layout';
import InputText from '../../../commonModules/interface/form-input-inline';
var    $ = require('jquery');

class DisplayUserInfo extends Component{
    state = { }

    render() {
        const { info, update, showUpdateForm } = this.props;
        let infoTmp = [];
        let x = '';
        let i=-1

        for ( x in info){
            i++
            const target = "#collapse"+i;
            if(!x.startsWith("Photo") && x !== "infoInstallation"){
                infoTmp.push(
                    <TableRow >
                        <TableCell component="th" >{x}</TableCell>
                        <TableCell>
                            {info[x]} 
                        </TableCell>   
                        {update &&
                            <TableCell>
                                <IconButton 
                                    color="primary" 
                                    onClick={() => this.props.updateTarget( showUpdateForm === target ? "" : target) }
                                >
                                    {showUpdateForm !== target ?
                                        <EditRounded /> :
                                        <CloseRounded />
                                    }
                                    </IconButton>
                            </TableCell>
                        }
                    </TableRow>
                );
            }
            if(x === "infoInstallation"){
                for (let y in info[x]){
                    infoTmp.push(
                        <TableRow >
                            <TableCell component="th" >{y}</TableCell>
                            <TableCell>
                                {info[x][y]} 
                            </TableCell>   
                            {update &&
                                <TableCell>
                                    <IconButton 
                                        color="primary" 
                                        onClick={() => this.props.updateTarget( showUpdateForm === target ? "" : target) }
                                    >
                                        {showUpdateForm !== target ?
                                            <EditRounded /> :
                                            <CloseRounded />
                                        }
                                        </IconButton>
                                </TableCell>
                            }
                        </TableRow>
                    );
                }
            }
            if(showUpdateForm === target && update){
                const schemas = this.props.updateInfo(x)
                console.log( schemas);
                infoTmp.push(
                    <TableRow className="dl-horizontal">
                        <TableCell colSpan={3}>
                            <Form
                                schema={schemas[0]}
                                uiSchema={schemas[1]}
                                formData={schemas[2]}
                                onSubmit={this.props.handleSubmit}
                            >
                                <Button type="submit" variant="contained" color="primary" >
                                    Valider
                                </Button>
                            </Form>                                
                        </TableCell>
                    </TableRow>
                );
            }
        }
        return (
            <Box>
                <TableLayout>
                    <TableBody>
                        {infoTmp}
                    </TableBody>
                </TableLayout>
            </Box>
        )
    }
}
export default DisplayUserInfo